import genericNotifications, {
  notificationAction,
  notificationTitles,
} from '../../utils/genericNotifications';

export const usersNotifications = {
  create: (name) =>
    genericNotifications(
      notificationTitles.collaborator,
      name,
      notificationAction.create,
    ),
  update: (name) =>
    genericNotifications(
      notificationTitles.collaborator,
      name,
      notificationAction.update,
    ),
  enable: (enabled) =>
    genericNotifications(notificationTitles.collaboratorEnable, enabled, null),
};
